import i18next from 'i18next'
import { initReactI18next } from 'react-i18next'
import { DEFAULT_LOCALE, type Locale } from '@hub/contracts'
import sv from './locales/sv'
import en from './locales/en'

export const resources = { sv, en } as const
export type Namespace = keyof typeof sv

/**
 * i18next singleton for the SPA. Namespaces are plain TS modules bundled
 * with the app (no lazy loading — the whole dictionary is small); the
 * active language is driven by `LocaleProvider` (./locale.tsx).
 */
export const i18n = i18next.createInstance()

void i18n.use(initReactI18next).init({
  resources,
  lng: DEFAULT_LOCALE,
  fallbackLng: DEFAULT_LOCALE,
  supportedLngs: ['sv', 'en'] satisfies Locale[],
  defaultNS: 'common',
  ns: Object.keys(sv),
  interpolation: { escapeValue: false }, // React escapes already
  returnNull: false,
  react: { useSuspense: false },
})

export default i18n
